import {Helmet} from '@dr.pogodin/react-helmet';
import {BreadcrumbType} from 'platform/components';

import {useParams} from 'react-router-dom';

import {useGetSectorQuery} from '@dms/api/warehouse';
import i18n from '@dms/i18n';
import {settingsRoutes, testIds} from '@dms/routes';
import {SettingsTemplate} from '@dms/settings/shared';
import {formatDocumentTitle} from '@dms/shared';

import {ParkingSectorForm} from './ParkingSectorForm';

const breadcrumbs: BreadcrumbType[] = [
  {
    label: i18n.t('page.vehicleSettings.labels.parking'),
    href: settingsRoutes.vehicleParking,
  },
];

export function VehicleParkingEdit() {
  const {id} = useParams();
  const {data, isLoading} = useGetSectorQuery({sectorId: id ?? ''});

  return (
    <>
      <Helmet
        title={formatDocumentTitle(
          data?.name ?? i18n.t('page.vehicleSettings.labels.parkingSector'),
          i18n.t('page.vehicleSettings.labels.parking'),
          i18n.t('page.settings.labels.title')
        )}
      />
      <SettingsTemplate
        isLoading={isLoading}
        header={{breadcrumbs}}
        data-testid={testIds.settings.vehicleParkingEdit('modal')}
      >
        <ParkingSectorForm editData={data} />
      </SettingsTemplate>
    </>
  );
}
